module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/portfolio-parallax-0993dc9392d54fce1d56132690172904.jpg";